// vuex/modules/file/store.js
//import Config from "../config"

import axios from "axios"
import Cookies from "js-cookie"

let Config = {}
try {
  Config = require("/config.js").default
} catch (err) {
  console.log("GraphQL: Couldn't find module config, using adc-web-components config")
  Config = require("/config.js").default
}

axios.defaults.withCredentials = true

const GraphQL = {
  namespaced: true,
  state: {
    DEBUG: false,
    loggedIn: false,
    username: "",
    personId: null,
    email: "",
    role: null,
    ready: false,
    expires: new Date(),
    warningTimer: null,
    graphqlTicket: "",
    ssoExpires: new Date(),
    graphqlTicketExpires: new Date(),
  },
  getters: {
    username: (state) => {
      return state.username
    },
    isReady: (state) => {
      return state.ready
    },
    isExpired: (state) => {
      return !state.loggedIn || Date.parse(state.ssoExpires) <= (new Date())
    },
    isLoggedIn: (state) => {
      return state.loggedIn
    },
  },
  mutations: {
    logout(state) {
      if (state.loggedIn) {
        state.loggedIn = false
        state.graphQlTicket = ""
        state.personId = ""
        state.username = ""
        state.role = ""
        state.email = ""
        state.ready = false
        state.canEdit = false
        state.canEditFcRecord = false
        state.canViewFcRecord = false
        state.canViewFcFunding = false
        state.canEditFcFunding = false
        state.ssoExpires = new Date()
        state.graphqlTicketExpires = new Date()
        Cookies.remove("graphql.sid", { path: "/" })
      }
    },
    processGraphqlResponse(state, response) {
      if (state.DEBUG) console.log("Auth Response:", response)
      state.graphqlTicket = response.data.split(":")[0]
      state.username = response.data.split(":")[1]
      state.personId = response.data.split(":")[2]
      state.role = response.data.split(":")[3]
      state.expires = new Date(0)
      state.expires.setUTCSeconds(response.data.split(":")[4])
      state.ssoExpires = new Date()
      state.ssoExpires.setMinutes( state.ssoExpires.getMinutes() + Config.auth.sessionExpirationMinutes )
      state.loggedIn = true
      state.ready = true
      
      //window.location = response.path
    },
    updateEmail(state, email) {
      state.email = email
    },
    resetSessionExpiration(state) {
      if (Date.parse(state.ssoExpires) <= new Date()) {
        state.ssoExpires = new Date()
        state.ssoExpires.setMinutes( state.ssoExpires.getMinutes() + Config.auth.sessionExpirationMinutes )
      }
    },
  },
  actions: {
    logout: ({commit}) => {
      commit("logout")
    },
    loginWithTicket: ({state, commit, dispatch}, ticket) => {
      return new Promise((resolve, reject) => {
        if (state.DEBUG) console.log("ticket:", ticket)
        
        if (ticket !== null && ticket !== "") {
          Cookies.remove("graphql.sid", { path: "/" })
        } else {
          reject("Missing ticket")
        }
  
        axios.get(`${Config.graphql.host}/authenticate`, {
          params: {
            service: encodeURI(Config.auth.serviceName),
            ticket: encodeURI(ticket),
          },
        })
          .then((response) => {
            if (response.data) {
              commit("processGraphqlResponse", { 
                data: response.data,
              })
              resolve(response)
            } else {
              reject("Invalid GraphQL Response")
            }
          })
          .catch(error => {
            console.error("checkLogin Error:", error)
            reject("Failed to validate against GraphQL")
          })
      })
        .catch(error => {
          console.log("Error", error)
          reject(error)
        })
    },
    checkLogin: ({commit, state}, to) => {
      if (state.DEBUG) console.log("to:", to)
      if (state.DEBUG) console.log("location:", window.location)
      if (state.DEBUG) console.log("location href:", window.location.href)
      if (state.DEBUG) console.log("location pathname:", window.location.pathname)
      if (state.DEBUG) console.log("url:", window.location.origin + window.location.pathname)
      if (state.DEBUG) console.debug(`[Action Start] checkLogin`)

      if (window.location.href.indexOf("ticket") > -1) {
        Cookies.remove("graphql.sid", { path: "/" })

  
        axios.get(`${Config.graphql.host}/authenticate`, {
          params: {
            service: encodeURI(Config.auth.serviceName),
            ticket: encodeURI(window.location.search.replace("?ticket=", "")),
          },
        })
          .then((response) => {
            if (response.data) {
              commit("processGraphqlResponse", { 
                data: response.data,
                path: `${Config.app.host}/${to.hash}`,
              })
            }
          })
          .catch(error => {
            console.error("checkLogin Error:", error)
          })
      } else if (!state.loggedIn || Date.parse(state.ssoExpires) <= new Date()) {
        window.location =  `${Config.auth.cas}login?service=${encodeURI(window.location.href)}`
      }
      if (state.DEBUG) console.debug(`[Action End] checkLogin`)
    },
    retrieveEmail: ({rootState, commit, state}) => {
      return axios({
        method: "post",
        url: Config.graphql.host,
        data: {
          query:
            `{
              personByPersonId(personId: ${state.personId}) {
                email
              }
            }`,
        },
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          authorization: `Bearer ${rootState.auth.graphqlTicket}`,
        },
      })
        .then((response) => {
          if (response.data) {
            commit("updateEmail", response.data.data.personByPersonId.email)
            return response.data.data.personByPersonId.email
          }
        })
        .catch(error => {
          console.error("checkLogin Error:", error)
          return ""
        })
    },
    resetSessionExpiration: ({commit}) => {
      commit("resetSessionExpiration")
    },
  },
}

export default GraphQL
